import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Toaster } from './components/ui/sonner';

// Add cursor state handling for mouse down/up
document.addEventListener('DOMContentLoaded', () => {
  const html = document.documentElement;
  const body = document.body;
  
  document.addEventListener('mousedown', () => {
    html.classList.add('is-mouse-down');
    body.classList.add('is-mouse-down');
  });
  
  document.addEventListener('mouseup', () => {
    html.classList.remove('is-mouse-down');
    body.classList.remove('is-mouse-down');
  });
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <Toaster position="top-right" />
  </React.StrictMode>
);